import { render, staticRenderFns } from "./ModalLikers.vue?vue&type=template&id=82755aac&"
import script from "./ModalLikers.vue?vue&type=script&lang=ts&"
export * from "./ModalLikers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports